import React, { Component } from 'react';
import { Col, Row, Badge } from 'react-bootstrap';

import '../Styles.css';

import ComprobanteStatusBadge from './ComprobanteStatusBadge';
import TipoComprobante from '../../support/enum/TipoComprobante';
import SingleComprobanteActions from './SingleComprobanteActions';
import ComprobanteCancelacionStatus from './ComprobanteCancelacionStatus';
import SingleComprobanteCancelAction from './SingleComprobanteCancelAction';
import SingleComprobanteCloneActions from './SingleComprobanteCloneActions';

class ComprobanteStatusInfo extends Component {
  render() {
    const { data = {} } = this.props;

    const tipo = TipoComprobante.search(data.tipo) || TipoComprobante.undefined()

    return (
      <>
        <Row className="mt-3 mb-1">
          <Col xs={ 12 } sm={ 12 } md={ 8 } className="mb-2">
            <div className="d-inline-block mr-3">
              <span className="text-muted">Tipo:</span>
              <br/>
              <Badge pill variant="info">
                { tipo.getName() || '...' }
              </Badge>
            </div>

            <div className="d-inline-block mr-3">
              <span className="text-muted">Ambiente:</span>
              <br/>
              <Badge pill variant="warning">
                { data.live !== undefined ? (data.live ? 'Producción' : 'Test') : '...' }
              </Badge>
            </div>

            <div className="d-inline-block mr-3">
              <span className="text-muted">Status:</span>
              <br/>
              <ComprobanteStatusBadge status={ data.status } />
            </div>

            { data.cancelacion_status !== null && (
              <div className="d-inline-block mr-3">
                <span className="text-muted">Status Cancelación:</span>
                <br/>
                <ComprobanteCancelacionStatus
                  status={ data.cancelacion_status }
                  cancelacion_comentario={ data.cancelacion_comentario }
                />
              </div>
            )}
          </Col>
          <Col xs={ 12 } sm={ 12 } md={ 4 } className="text-right">
            <SingleComprobanteActions data={ data } />
          </Col>
        </Row>

        <Row>
          <Col xs={ 12 } sm={ 6 } md={ 4 }>
            <SingleComprobanteCancelAction data={ data } />
          </Col>
          <Col xs={ 12 } sm={ 6 } md={ 8 }>
            <SingleComprobanteCloneActions data={ data } />
          </Col>
        </Row>
      </>
    )
  }
}

export default ComprobanteStatusInfo;